import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const InventoryTurnovers = React.lazy(() => import('./index'));
const ItTable = React.lazy(() => import('./itTable'));
const InventoryTurnover = React.lazy(() => import('./inventoryTurnover'));
const ItDetail = React.lazy(() => import('./itDetail'));
const AddNewInventoryTurnover = React.lazy(() => import('./addNewInventoryTurnover'));
const EditInventoryTurnover = React.lazy(() => import('./editInventoryTurnover'));

export const useInventoryTurnoverRoutes = () => {
    return (
        <React.Fragment>
            <Route path="inventoryTurnover" element={<Suspense fallback={<div>منتظر باشید...</div>}><InventoryTurnovers isEstimated={false} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ItTable isEstimated={false}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewInventoryTurnover isEstimated={false}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><InventoryTurnover isEstimated={false}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ItDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditInventoryTurnover /></Suspense> } />
                </Route>
            </Route>
            <Route path="inventoryTurnoverEstimated" element={<Suspense fallback={<div>منتظر باشید...</div>}><InventoryTurnovers isEstimated={true} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ItTable isEstimated={true}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewInventoryTurnover isEstimated={true}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><InventoryTurnover isEstimated={true}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ItDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditInventoryTurnover /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}